// extracted by mini-css-extract-plugin
export default {"main":"TemplateEditor_main__Ga56f","footerButtons":"TemplateEditor_footerButtons__4SbLF","infoMsg":"TemplateEditor_infoMsg__0VFe9"};